import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { ValidateComponent } from './pages-front/validate-email/validate-email.component';
import { ImportRequestComponent } from './pages-front/import-request/import-request.component';
import { ExtensionComponent } from './pages-front/extension/extension.component';
import { LoginBackComponent } from './pages-back/login-back/login-back.component';
import { ImportBackComponent } from './pages-back/import-back/import-back.component';
import { ExtensionBackComponent } from './pages-back/extension-back/extension-back.component';
import { ManageImportComponent } from './pages-back/manage-import/manage-import.component';
import { PortalBackComponent } from './pages-back/portal-back/portal-back.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { UploadFilesComponent } from './upload-files/upload-files.component';
import { AzureStorageModule } from './azure-storage/azure-storage.module';
import { HeadBackComponent } from './pages-back/head-back/head-back.component';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserMenuComponent } from './pages-back/user-menu/user-menu.component';
import { FinishImportComponent } from './pages-back/finish-import/finish-import.component';
import { FinishManageImportComponent } from './pages-back/finish-manage-import/finish-manage-import.component';
import { PersonalDataComponent } from './pages-front/personal-data/personal-data.component';
import { GenerateReportComponent } from './pages-back/generate-report/generate-report.component';
import { HistoryImportComponent } from './pages-front/history-import/history-import.component';
import { Globals } from './globals';
import { NgxPaginationModule } from 'ngx-pagination'
import { CookieService } from 'ngx-cookie-service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    ValidateComponent,
    LoginBackComponent,
    ImportRequestComponent,
    UploadFilesComponent,
    ExtensionComponent,
    ImportBackComponent,
    ExtensionBackComponent,
    ManageImportComponent,
    PortalBackComponent,
    HeadBackComponent,
    UserMenuComponent,
    PersonalDataComponent,
    FinishImportComponent,
    FinishManageImportComponent,
    GenerateReportComponent,
    HistoryImportComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,    
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    AzureStorageModule,
    MatMenuModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot([
      { path: '', redirectTo:'validate-email', pathMatch: 'full' },
      { path: 'validate-email', component: ValidateComponent },
      { path: 'login-back', component: LoginBackComponent },
      { path: 'import-request/:accion/:email/:numserial/:idimport/:volver', component: ImportRequestComponent },
      { path: 'extension/:accion/:idimport/:idextend', component: ExtensionComponent },
      { path: 'import-back/:accion/:email/:numserial/:idimport/:volver', component: ImportBackComponent },
      { path: 'extension-back/:accion/:idimport/:idextend/:volver', component: ExtensionBackComponent },
      { path: 'manage-import', component: ManageImportComponent },
      { path: 'portal-back', component: PortalBackComponent },
      { path: 'personal-data', component: PersonalDataComponent },
      { path: 'finish-import', component: FinishImportComponent },
      { path: 'finish-manage-import/:postid', component: FinishManageImportComponent },
      { path: 'generate-report', component: GenerateReportComponent },
      { path: 'history-import/:email/:numserial', component: HistoryImportComponent },
    ])
  ],
  providers: [Globals, CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
